<template>
    <v-timeline
            id="SubstituteTimeline"
            class="pl-4 pr-4"
            align-top
    >
        <v-timeline-item
            :v-if="timeGrouped.length"
            v-for="(block, i) in timeGrouped"
            :key="'item-'+block.time"
            :class="editingOne && !block.editing ? 'opacityLow' : ''"
            fill-dot
            icon=""
            icon-color=""
            small
        >
            <template v-slot:icon>
                <v-card tile flat class="timelineTime theme-back" :class="block.editing ? 'editing' : ''">{{block.time}}</v-card>
                <v-card v-if="(i === 0) && !block.editing && block.time >= '00:00'" flat tile class="timelineActions">
                    <v-btn class="timelineAction theme-background theme-hightext theme-highborder" @click="deleteTime(block.time)" tile depressed>
                        <v-icon class="theme-hightext">mdi-trash-can-outline</v-icon>
                    </v-btn>
                    <!--
                    <v-btn v-if="time >= block.time" class="timelineAction theme-background theme-hightext theme-highborder" @click="editTime(block.time)" tile depressed>
                        <v-icon class="theme-hightext">mdi-pencil</v-icon>
                    </v-btn>
                    -->
                </v-card>
                <v-card v-if="block.editing" flat tile class="theme-invbackground theme-invtitle timelineBubble px-3" height="28">
                    {{actionText(block)}}
                </v-card>
                <v-card v-if="block.editing" flat tile class="timelineActions">
                    <v-btn class="timelineAction theme-background theme-hightext theme-highborder" @click="saveAll" tile depressed>
                        <v-icon class="theme-hightext">mdi-check</v-icon>
                    </v-btn>
                </v-card>
            </template>

            <v-card v-if="block['B'] && block['B'].length" :slot="!isMirrored ? 'opposite' : 'default'" flat tile class="transparent">
                <v-card flat tile class="theme-highlight mb-3"
                        :class="(block.editing && !item.editing) ? 'opacityLow' : ''"
                        v-for="item in block['B']"
                        :key="item.UUID"
                >
                    <v-card
                            flat
                            tile
                            class="timelineItem theme-highlight theme-border-inverse"
                            v-on="{'click': !block.editing && !item.editing ? () => {editEvent(item, block.time, (i === 0))} : () => {}}"
                    >
                        <v-progress-circular v-if="item.editing && saveItems[item.UUID]"
                                             v-show="saveItems[item.UUID] < 100"
                                             :rotate="270"
                                             :size="32"
                                             :value="saveItems[item.UUID]"
                                             color="#23C373"
                                             class="ml-2 mt-1 prog-circle"
                                             :class="!isMirrored ? 'left-circle' : 'right-circle'"
                        >{{ Math.round(saveTime - Math.floor(saveTime * (saveItems[item.UUID] / 100))) }}</v-progress-circular>
                        <TimelineExcludeEnd :gamefinished="gamefinished" v-if="item.action === 'Felmegy'" :element="item"/>
                        <TimelineExchange :gamefinished="gamefinished" v-if="item.action === 'Csere'" :element="item"/>
                        <TimelineExclude  :gamefinished="gamefinished" v-if="item.action === 'Kiállítás'" :element="item"/>
                        <TimelineOfficialExclude  :gamefinished="gamefinished" v-if="item.action === 'Hivatalos Kiállítás'" :element="item"/>
                    </v-card>

                    <TimelineAction v-if="item.editing" :element="item" team="B"/>
                </v-card>
            </v-card>

            <v-card v-if="block['A'] && block['A'].length" :slot="!isMirrored ? 'default' : 'opposite'" flat tile class="transparent">
                <v-card flat tile class="theme-highlight mb-3"
                        :class="(block.editing && !item.editing) ? 'opacityLow' : ''"
                        v-for="item in block['A']"
                        :key="item.UUID"
                >
                    <v-card
                            flat
                            tile
                            class="timelineItem theme-highlight theme-border-inverse"
                            v-on="{'click': !block.editing && !item.editing ? () => {editEvent(item, block.time, (i === 0))} : () => {}}"
                    >
                        <v-progress-circular v-if="item.editing && saveItems[item.UUID]"
                                             v-show="saveItems[item.UUID] < 100"
                                             :rotate="270"
                                             :size="32"
                                             :value="saveItems[item.UUID]"
                                             color="#23C373"
                                             class="ml-2 mt-1 prog-circle"
                                             :class="!isMirrored ? 'right-circle' : 'left-circle'"
                        >{{ Math.round(saveTime - Math.floor(saveTime * (saveItems[item.UUID] / 100))) }}</v-progress-circular>
                        <TimelineExcludeEnd :gamefinished="gamefinished" v-if="item.action === 'Felmegy'" :element="item"/>
                        <TimelineExchange :gamefinished="gamefinished" v-if="item.action === 'Csere'" :element="item"/>
                        <TimelineExclude :gamefinished="gamefinished" v-if="item.action === 'Kiállítás'" :element="item"/>
                        <TimelineOfficialExclude :gamefinished="gamefinished" v-if="item.action === 'Hivatalos Kiállítás'" :element="item"/>
                    </v-card>

                    <TimelineAction v-if="item.editing" :element="item" team="A"/>
                </v-card>
            </v-card>
        </v-timeline-item>
    </v-timeline>
</template>

<script>
    import TimelineExchange from "@/components/TimelineExchange";
    import TimelineExclude from "@/components/TimelineExclude";
    import TimelineOfficialExclude from "@/components/TimelineOfficialExclude";
    import TimelineExcludeEnd from "@/components/TimelineExcludeEnd";
    import TimelineAction from "@/components/TimelineAction";
    import eventBus from '@/eventBus';
    import CONSTANTS from '@/constants';
    //var debug = require('debug')('MKSZ:SubstituteScreen');

    export default {
        name: "TimelineSubstitute",
        components: {
            TimelineExchange,
            TimelineExclude,
            TimelineOfficialExclude,
            TimelineExcludeEnd,
            TimelineAction,
        },
        props: {
            timelineData: Array,
            isMirrored: Boolean,
            gamefinished: Boolean,
            lazyLoadItems: Number,
            time: String,
        },
        data() {
            return {
                editingOne: false,
                saveItems: {},
                saveTime: 0,
                saveableItems: [],
            }
        },
        mounted() {
            this.saveTime = window.saveTime;
        },
        methods: {
            editEvent: function(item, itemTime, lastItem) {
                if(itemTime <= this.time && lastItem) {
                    eventBus.$emit(CONSTANTS.EVENTS.TIMELINE.ITEM.EDIT.ONE, item);
                } else {
                    if(!lastItem) {
                        eventBus.$emit(CONSTANTS.EVENTS.ALERTBOX, 'Csak az utolsó időpontra felvett események szerkeszthetőek!');
                    } else {
                        eventBus.$emit(CONSTANTS.EVENTS.ALERTBOX, 'Jövőbeli eseményt nem szerkeszthet, kérem állítsa az órát későbbre!');
                    }
                }
            },
            deleteTime: function(time) {
                eventBus.$emit(CONSTANTS.EVENTS.TIMELINE.ITEM.DELETE.ALL, time);
            },
            editTime: function(time) {
                eventBus.$emit(CONSTANTS.EVENTS.TIMELINE.ITEM.EDIT.ALL, time);
            },
            saveAll: function() {
                eventBus.$emit(CONSTANTS.EVENTS.TIMELINE.ITEM.SAVE.ALL);
            },
            actionText: function(item) {
                if(item.onlyNew) {
                    return 'Új csere';
                }

                if(item.excluded && !item.exchange) {
                    return 'Kiállítás';
                } else {
                    return 'Szerkesztés';
                }
            },
            spinnerRoll: function(id) {
                let self = this;

                if(self.saveItems[id] < 100 && window.autosave && window.saveTime > 0) {
                    self.saveItems[id] += 5 / window.saveTime;

                    if (self.saveItems[id] > 100) {
                        delete self.saveItems[id];

                        let element = {};

                        self.timelineData.forEach(item => {
                            if(item.UUID === id) {
                                element = item;
                            }
                        });

                        let players = {
                            up: element.up ? element.up : null,
                            down: element.down ? element.down : null
                        };

                        eventBus.$emit(CONSTANTS.EVENTS.TIMELINE.ITEM.SAVE.ONE, element.UUID, players, element.team, true);
                    } else {
                        window.setTimeout(() => {
                            self.spinnerRoll(id);
                        }, 45); //50
                    }
                } else {
                    delete self.saveItems[id];
                }
            },
        },
        computed: {
            timeGrouped: function() {
                let self = this;
                let rtn = [];
                let newSaveItems = {};
                let orderedList = [...self.timelineData].slice(0, self.lazyLoadItems);
                let tmpSavingItems = self.saveItems;
                let localSaveableItems = [];

                self.editingOne = false;

                orderedList.forEach(function (obj, index) {
                    let haveExchange = false;
                    let haveExclude = false;
                    let onlyNew = true;
                    let newItem = true;
                    let count = 0;
                    let blockData = {
                        UUID: obj.UUID,
                        up: obj.up,
                        down: obj.down,
                        excluded: obj.excluded,
                        action: obj.action,
                        duration: obj.duration,
                        editing: Boolean(obj.editing),
                        isNew: obj.isNew,
                        deletable: !obj.isNew,
                    };

                    if(index > 0 && orderedList[index-1].time === obj.time) {
                        newItem = false;
                    }

                    if(!self.editingOne && (blockData.editing || blockData.isNew)) {
                        self.editingOne = true;
                    }

                    if(window.autosave && window.saveTime > 0 && (blockData.editing || blockData.isNew) && blockData.action === "Csere" && blockData.up && blockData.down) {
                        newSaveItems[blockData.UUID] = self.saveItems[blockData.UUID] ? self.saveItems[blockData.UUID] : 0;
                        localSaveableItems.push(blockData.UUID);
                    }

                    if (newItem) {
                        rtn.push({
                            time:obj.time,
                            [obj.team]:[blockData]
                        });
                    } else {
                        count = rtn.length-1;

                        if(rtn[count][obj.team]) {
                            rtn[count][obj.team].push(blockData);
                        } else {
                            rtn[count][obj.team] = [blockData];
                        }
                    }

                    count = rtn.length-1;

                    if(!orderedList[index+1] || orderedList[index+1].time !== obj.time) {
                        ['A', 'B'].forEach(function (team) {
                            if(rtn[count][team]) {
                                rtn[count][team].forEach(function (obj) {
                                    if (!haveExclude && obj.action === 'Kiállítás') {
                                        haveExclude = true;
                                    }

                                    if (!haveExchange && obj.action === 'Csere') {
                                        haveExchange = true;
                                    }

                                    if(onlyNew && !obj.isNew) {
                                        onlyNew = false;
                                    }
                                });
                            }
                        });
                    }

                    rtn[count]['exchange'] = haveExchange;
                    rtn[count]['excluded'] = haveExclude;
                    rtn[count]['onlyNew'] = onlyNew;
                    rtn[count]['editing'] = Boolean(obj.editing);
                });

                if(window.autosave && window.saveTime > 0) {
                    let saveKeys = [];

                    localSaveableItems.forEach(function (localId) {
                        if (!self.saveableItems.includes(localId)) {
                            saveKeys.push(localId);
                        }
                    });

                    self.saveableItems = localSaveableItems;
                    self.saveTime = window.saveTime;
                    self.saveItems = newSaveItems;

                    if(saveKeys.length === 1 && Object.keys(tmpSavingItems).length || (Object.keys(newSaveItems).length <= 1)) {
                        //@TODO 1db elem szerkesztésekor automentés visszaszámláló elindul

                        Object.keys(newSaveItems).forEach(function (key) {
                            if(!tmpSavingItems[key] && key === saveKeys[0]) {
                                self.spinnerRoll(key);
                            }
                        });
                    }
                }

                return rtn;
            },
        }
    }
</script>

<style>
    #SubstituteTimeline {
        width: 100%;
        align-items: flex-start;
    }

    #SubstituteTimeline:before {
        border-style: dotted;
        width: 1px;
        border-left-width: 0;
        border-right-width: 2px;
        border-top-width: 0;
        border-bottom-width: 0;

        background: transparent;
        height: calc(100% + 60px);
        top: -60px;
    }

    #SubstituteTimeline.theme--light:before {
        border-right-color: #aaaaaa;
    }

    #SubstituteTimeline.theme--dark:before {
        border-right-color: #4d5269;
    }

    #SubstituteTimeline .v-timeline-item {
        flex-direction: row !important;
    }

    #SubstituteTimeline .v-timeline-item__divider {
        width: 124px;
    }

    #SubstituteTimeline .v-timeline-item__body {
        align-self: flex-start;
        padding-right: 16px;
        position: relative;
        max-width: calc(50% - 62px) !important;
        width: calc(50% - 62px) !important;
        background-color: transparent !important;
    }

    #SubstituteTimeline.theme--light .v-timeline-item__body:before {
        border-color: #000000;
    }

    #SubstituteTimeline.theme--dark .v-timeline-item__body:before {
        border-color: #ffffff;
    }

    #SubstituteTimeline .v-timeline-item__body:not(:empty):before {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: calc(100% + 62px);
        height: 0;
        border-width: 0;
        border-top-width: 1px;
        border-style: solid;
    }

    #SubstituteTimeline .v-timeline-item__opposite {
        align-self: flex-start;
        padding-left: 16px;
        position: relative;
        max-width: calc(50% - 62px) !important;
        width: calc(50% - 62px) !important;
        background-color: transparent !important;
    }

    #SubstituteTimeline.theme--dark .v-timeline-item__opposite:before {
        border-color: #ffffff;
    }

    #SubstituteTimeline.theme--light .v-timeline-item__opposite:before {
        border-color: #000000;
    }

    #SubstituteTimeline .v-timeline-item__opposite:not(:empty):before {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        left: auto;
        width: calc(100% + 62px);
        height: 0;
        border-width: 0;
        border-top-width: 1px;
        border-style: solid;
    }

    #SubstituteTimeline .v-timeline-item__dot {
        width: auto;
        height: auto;
        background-color: transparent;
        left: auto;
        box-shadow: none;
        border-radius: 0;
    }

    #SubstituteTimeline .v-timeline-item__dot .v-timeline-item__inner-dot {
        height: auto;
        width: auto;
        background-color: transparent !important;
        display: flex;
        flex-flow: column;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
</style>

<style scoped>
    .timelineTime {
        white-space: nowrap;
        line-height: 36px;
        height: 36px;
        font-size: 18px;
        font-weight: 900;
        transition: all 300ms;
        margin-top: 1px;
    }

    .timelineTime.editing {
        line-height: 44px;
        height: 44px;
        font-size: 30px;
    }

    .timelineActions {
        display: flex;
        flex-flow: row;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        flex-wrap: nowrap;
    }

    .timelineAction {
        min-width: 46px !important;
        width: 46px;
        min-height: 46px;
        height: 46px;
        border: 1px;
        border-style: solid;
    }

    .timelineAction:nth-child(n+2) {
        width: 45px;
        border-left-width: 0;
    }

    .timelineItem {
        padding: 10px;
        border-width: 1px;
        border-style: solid;
    }

    .timelineBubble {
        font-size: 12px;
        line-height: 28px;
        font-stretch: condensed;
        font-family: 'Roboto Condensed';
        font-style: italic;
        border-radius: 14px;
        text-align: center;
        margin-bottom: 10px;
    }

    .prog-circle {
        position: absolute;
        top: 0;
        z-index: 1;
    }

    .left-circle {
        left: -45px;
    }

    .right-circle {
        right: -37px;
    }

    .opacityLow {
        opacity: 0.3;
        pointer-events: none;
    }
</style>
